import Base from './base'
import { FrontendInstallation, FrontendInstallationParams } from '../types/frontendInstallation'

export default class FrontendInstallations extends Base {
  async getFrontendInstallations(
    searchParams: FrontendInstallationParams
  ): Promise<FrontendInstallation[]> {
    const response = await this.api.get('frontend_installations', { params: searchParams })
    return Array.isArray(response?.data) ? response?.data : []
  }
}
